import { useAccount } from "wagmi";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { selectBuyMode, setAmount } from "../features/trade";
import { Chains, SpaceBalanceOfABI, WBTCBalanceABI } from "./data";
import { useSelector } from "react-redux";
import { selectChain } from "../features/chain";
import { selectToken } from "../features/token";
import { selectAddress } from "../features/account";
import { ethers } from "ethers";
import { emptyEthAddress } from "../utils/util";
import { getInjectedWalletAddress, hasInjectedProvider } from "../lib/injectedWallet";

const SetMaxButton = () => {
  const { address: ethAddress } = useAccount();
  const dispatch = useAppDispatch();
  const buyMode = useAppSelector(selectBuyMode);
  const chain = useSelector(selectChain);
  const token = useSelector(selectToken);
  const jicAddress = useAppSelector(selectAddress);
  const accountAddress =
    ethAddress ||
    (jicAddress && jicAddress !== emptyEthAddress
      ? (jicAddress as `0x${string}`)
      : undefined);

  const resolveAccountAddress = async () => {
    if (accountAddress) return accountAddress;
    if (!hasInjectedProvider()) return undefined;
    return getInjectedWalletAddress({ requestIfNeeded: false }).catch(() => undefined);
  };

  const formatMaxAmount = (balance: string, decimals: number) => {
    const [integerPart, fractionPart = ""] = balance.split(".");
    if (!integerPart || /^0+$/.test(integerPart + fractionPart)) return "";
    const maxFractionDigits = buyMode ? Math.min(decimals, 8) : 6;
    const nextAmount =
      maxFractionDigits > 0 && fractionPart
        ? integerPart + "." + fractionPart.slice(0, maxFractionDigits)
        : integerPart;
    return nextAmount.replace(/(.d*?[1-9])0+$|.0*$/, "$1");
  };

  async function ethSetMax() {
    const owner = await resolveAccountAddress();
    if (!owner) return;
    const collateral = Chains[chain].wbtcAddr[token];
    const contractAddress = buyMode ? collateral.addr : Chains[chain].contractAddr;
    const abi = buyMode ? WBTCBalanceABI : SpaceBalanceOfABI;
    const decimal = buyMode ? collateral.decimal : 18;
    try {
      const provider = new ethers.JsonRpcProvider(Chains[chain].provider);
      const contract = new ethers.Contract(contractAddress, abi, provider);
      const data = await contract.balanceOf(owner);
      const balance = ethers.formatUnits(data.toString(), decimal);
      dispatch(setAmount(formatMaxAmount(balance, decimal)));
    } catch (error) {
      console.log(
        "Failed to fetch max balance:",
        error instanceof Error ? error.message : error
      );
    }
  }

  return (
    <button
      type="button"
      className="relative z-10 border border-2 border-[#999] text-[#999] text-xs md:text-sm mt-1.5 md:mt-2 font-bold rounded-full px-2 mx-2 touch-manipulation"
      onClick={ethSetMax}
    >
      MAX
    </button>
  );
};
export default SetMaxButton;
